"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
var React = __importStar(require("react"));
function Fosa(_a) {
    var width = _a.width, height = _a.height, className = _a.className;
    return (React.createElement("svg", { width: "20", height: "23", viewBox: "0 0 30 23", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M10.459 0.0903606C8.29688 0.468086 6.35156 1.8817 5.34961 3.80466C4.86914 4.72609 4.67578 5.37852 4.57617 6.41441C4.38281 8.38316 5.08594 10.392 6.49805 11.9029L6.84961 12.2863L6.48633 12.4122C4.31836 13.1791 2.21484 15.1021 1.06641 17.3627C0.316406 18.845 0 20.2071 0 21.9985V23H11.7773H23.5547V22.0271C23.5547 20.0011 23.0859 18.3013 22.0723 16.6359C21.498 15.6859 20.5371 14.6042 19.6406 13.8888C18.8848 13.2821 17.6602 12.5954 16.9219 12.3607C16.7988 12.3207 16.6992 12.2749 16.6992 12.2577C16.6992 12.2405 16.8809 12.0402 17.1035 11.8113C18.0527 10.8327 18.6797 9.57357 18.9258 8.15423C19.0195 7.59337 19.0078 6.40868 18.8965 5.80203C18.4102 3.12361 16.3359 0.908768 13.6699 0.227716C13.418 0.164762 13.0547 0.0846386 12.8672 0.0502987C12.375 -0.0298252 11.0156 -0.0126553 10.459 0.0903606ZM13.1543 2.45973C15.416 3.12934 16.8926 5.29268 16.6348 7.54758C16.4531 9.14433 15.5098 10.5064 14.0566 11.2562C12.627 12.0002 11.0918 12.0288 9.64453 11.3306C8.09766 10.5866 7.1543 9.29313 6.9082 7.5762C6.77344 6.64333 7.02539 5.49871 7.55859 4.62307C7.83398 4.17094 8.47852 3.47845 8.90625 3.1694C10.0664 2.33382 11.7773 2.04767 13.1543 2.45973ZM15 14.2207C16.4531 14.4897 17.7656 15.2166 18.9375 16.4127C19.793 17.2769 20.4258 18.2899 20.8008 19.3887C20.9414 19.7893 21.1523 20.6135 21.1523 20.7451C21.1523 20.7565 16.9336 20.768 11.7773 20.768C3.67969 20.768 2.40234 20.7565 2.40234 20.6879C2.40234 20.4876 2.76562 19.2628 2.95312 18.8278C3.94922 16.5272 6.09375 14.7186 8.38477 14.2494C8.88867 14.1463 9.1875 14.1349 11.7246 14.1349C14.0273 14.1292 14.6016 14.1463 15 14.2207Z", fill: "white" }),
        React.createElement("path", { d: "M24.2578 7.94844V9.60814H22.5586H20.8594V10.7528V11.8974H22.5586H24.2578V13.5571V15.2168H25.4297H26.6016V13.5571V11.8974H28.3008H30V10.7528V9.60814H28.3008H26.6016V7.94844V6.28873H25.4297H24.2578V7.94844Z", fill: "white" })));
}
Fosa.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
Fosa.defaultProps = {
    width: 64,
    height: 64,
};
exports.default = Fosa;
